import { getBadgeConfig } from 'helpers/ConfigHelper';

export const SHOW_STATE_AUDIO = 'AUDIO';
export const SHOW_STATE_LIVE = 'LIVE';
export const SHOW_STATE_UPNEXT = 'UP NEXT';
export const SHOW_STATE_REPLAY = 'REPLAY';
export const SHOW_STATE_UPCOMING = 'UPCOMING';
export const SHOW_STATE_CLIP = 'CLIP';
export const SHOW_STATE_INFO = 'INFO';
export const SHOW_STATE_FREE = 'FREE';
export const NEW_EPISODE_BADGE = 'NEW EPISODE';

export const formatDurationClipFormat = duration => {
  const getTimeWithPrefix = time => (time < 10 ? `0${time}` : `${time}`);
  const seconds = Math.round(duration % 60);
  const minutes = Math.round(duration / 60);
  const hours = Math.floor(minutes / 60);

  const hoursText = hours ? `${hours}:` : '';
  const minutesText = hours ? `${getTimeWithPrefix(minutes)}:` : `${minutes}:`;

  return `${hoursText}${minutesText}${getTimeWithPrefix(seconds)}`;
};

/**
 * Get the user friendly string for a specific contentLabel
 *
 * @param contentLabel
 * @returns {*}
 */
export const getLiveStatusBadge = contentLabel => {
  if (!contentLabel) return null;

  let status = contentLabel;
  if (Array.isArray(contentLabel)) [status] = contentLabel;

  if (status.toLowerCase() === 'live') return SHOW_STATE_LIVE;
  if (status.toLowerCase().replace(' ', '') === 'upnext') return SHOW_STATE_UPNEXT;
  if (status.toLowerCase() === 'replay') return SHOW_STATE_REPLAY;

  return null;
};

export const getBadgeLabel = badge => {
  const badgeConfig = getBadgeConfig();
  if (!badgeConfig || !badge) return null;

  const badgeType = badge?.toLowerCase()?.replace(/ /g, '');
  const badgeConfigKeys = Object.keys(badgeConfig);
  const item = badgeConfigKeys?.find(item => item === badgeType);
  const label = item ? badgeConfig[item]?.label : null;
  return `${label || badge.toUpperCase()}`;
};

export const getBadgeClass = (badge, theme) => {
  if (!badge || !theme) return null;

  const slug = text => text && text.toLowerCase().replace(/ /g, '');
  const badgeConfig = getBadgeConfig();
  const badgeType = slug(badge);
  const badgeConfigKeys = Object.keys(badgeConfig);
  const item = badgeConfigKeys.find(item => {
    const slugLabel = slug(badgeConfig[item].label);
    return item === badgeType || slugLabel === badgeType;
  });
  const colorKey = item ? `${badgeConfig[item].color}Badge` : null;
  const fallbackColor = `${badgeType}Badge`;
  return theme[colorKey] || theme[fallbackColor] || theme.defaultBadge;
};
